import { motion } from "framer-motion";

const contactInfo = [
  {
    label: "Contacts us",
    value: "+1 (770) 8383-KGS",
    icon: (
      // Person/support icon
      <svg viewBox="0 0 28 28" fill="none" className="w-6 h-6 text-white" xmlns="http://www.w3.org/2000/svg">
        <circle cx="14" cy="9" r="5" stroke="white" strokeWidth="1.8" />
        <path d="M5 24c0-5 4-9 9-9s9 4 9 9" stroke="white" strokeWidth="1.8" strokeLinecap="round" />
        {/* Headset arc */}
        <path d="M8 13a8 8 0 0116 0" stroke="white" strokeWidth="1.6" strokeLinecap="round" fill="none" />
        <rect x="6" y="13" width="3" height="5" rx="1.5" fill="white" />
        <rect x="19" y="13" width="3" height="5" rx="1.5" fill="white" />
      </svg>
    ),
  },
  {
    label: "Our Email",
    value: "info@kgstechnologygroup.com",
    icon: (
      // Envelope icon
      <svg viewBox="0 0 28 28" fill="none" className="w-6 h-6 text-white" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="6" width="22" height="16" rx="3" stroke="white" strokeWidth="1.8" />
        <path d="M3 9l11 8 11-8" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    label: "Location",
    value: "2440 Old Milton Parkway, Suite 117, Alpharetta, GA - 30009",
    icon: (
      // House/location icon
      <svg viewBox="0 0 28 28" fill="none" className="w-6 h-6 text-white" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 12L14 4l10 8v11a2 2 0 01-2 2H6a2 2 0 01-2-2V12z" stroke="white" strokeWidth="1.8" strokeLinejoin="round" />
        <rect x="10" y="17" width="8" height="8" rx="1" stroke="white" strokeWidth="1.6" />
        <circle cx="22" cy="8" r="4" stroke="white" strokeWidth="1.5" fill="none" />
        <path d="M22 6v4M20 8h4" stroke="white" strokeWidth="1.2" strokeLinecap="round" />
      </svg>
    ),
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: -30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, delay: i * 0.14, ease: "easeOut" },
  }),
};

export default function ContactMapSection() {
  return (
    <section className="w-full relative overflow-hidden">

      {/* ── Floating Info Cards ── */}
      <div className="relative z-20 max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-10 pb-0">
          {contactInfo.map((info, i) => (
            <motion.div
              key={info.label}
              custom={i}
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              whileHover={{ y: -4, boxShadow: "0 16px 40px rgba(59,130,246,0.12)" }}
              transition={{ type: "spring", stiffness: 260, damping: 22 }}
              className="bg-white rounded-2xl shadow-lg border border-gray-100 px-6 py-5 flex items-center gap-5"
            >
              {/* orange icon box */}
              <div className="w-14 h-14 rounded-xl bg-orange-500 flex items-center justify-center shrink-0">
                {info.icon}
              </div>

              {/* Text */}
              <div>
                <p className="text-gray-900 font-bold text-[1.05rem] leading-tight">{info.label}</p>
                <p className="text-gray-500 text-[0.9rem] mt-0.5">{info.value}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* ── Google Map Embed ── */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.2 }}
        className="w-full -mt-8 relative z-10"
      >
        <iframe
          title="AgileTech Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3304.9395722017844!2d-84.29076952448254!3d34.071063273149925!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f575992bea6e25%3A0x11ac7f1b7cfedc66!2s2440%20Old%20Milton%20Pkwy%20Suite%20117%2C%20Alpharetta%2C%20GA%2030009%2C%20USA!5e0!3m2!1sen!2sin!4v1774115858272!5m2!1sen!2sin"
          width="100%"
          height="480"
          style={{ border: 0, display: "block" }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
        
      </motion.div>

    </section>
  );
}